export const WIDGET_STEPS = [
    "chooseDevice", // Выбор устройства для сдачи
    "howYouRateDevice", // Пользовательская оценка
    "leaveContacts", // Контакты компании для предложения по выкупу
    "uploadDevicesList", // Загрузка списка техники компании
    "thanksForOrder", // Заявка отправлена
] as const;

export type WidgetStep = (typeof WIDGET_STEPS)[number];

export const FIRST_STEP: WidgetStep = "chooseDevice";
